export default __webpack_public_path__ + "static/media/Map.448d32e5.png";